import { useEffect } from 'react';
import { bCService, IBroadcastChannelHandlers } from '../events/broadcastChannel';


export const useHandleBroadcastChannel = ({
  handleCollectFormFields,
  handlePermissions,
  handleChangePotentialCardType,
}: IBroadcastChannelHandlers, sessionId: string, libInitializeId: string) => {
  useEffect(() => {
    bCService.init({
      handleCollectFormFields,
      handlePermissions,
      handleChangePotentialCardType,
    }, sessionId, libInitializeId);

    return () => {
      bCService.closeBroadcastChannel();
    };
  }, []);
};
